import useAxios from 'hooks/useAxios';

export async function createSkin(
  name,
  priceGems,
  priceCoins,
  unrealAvatarId,
  avatarId,
  smallImage,
  bigImage,
  textImage,
  rarity
) {
  const api = useAxios();
  const formData = new FormData();
  formData.append('name', name);
  formData.append('unrealSkinId', unrealAvatarId);
  formData.append('priceGems', priceGems);
  formData.append('priceCoins', priceCoins);
  formData.append('rarity', rarity);
  formData.append('avatarId', avatarId);
  formData.append('smallImage', smallImage);
  formData.append('bigImage', bigImage);
  formData.append('coverImage', textImage);

  try {
    const res = await api.post('/skins', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res;
  } catch (err) {
    return err;
  }
}
